// components/Modal/Modal.styles.ts
import { SxProps, Theme } from '@mui/material/styles';

export const modalStyles: Record<string, SxProps<Theme>> = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 2,
      boxShadow: (theme) => theme.shadows[10],
    },
  },
  
  title: {
    padding: 3,
    borderBottom: '1px solid',
    borderBottomColor: 'divider',
  },
  
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  
  closeButton: {
    color: 'text.secondary',
    '&:hover': {
      color: 'text.primary',
    },
  },
  
  content: {
    padding: 3,
  },
};